
/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {View} from 'backbone';
import {Model}  from 'backbone';
import template from 'dashboard/connections/details/action-web-services.ejs';
import * as gridModels from '../action-type/ActionGridModels';
import util from 'util/Util';
import constants from 'Constants';
import RestService from 'RestService';
import xJService from 'xml/XJService';
import NotificationService from 'NotificationService.js';
import FormLoadService from 'FormLoadService';
import sequenceService from 'SequenceService';
import AutocompleteWebserviceModalView from 'dashboard/connections/details/AutocompleteWebserviceModalView.js';
import _ from 'lodash';
import DashboardTable from 'dashboard/BaseDashboardTableView.js';


class ActionWebServices extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'change select[name=_method],select[name=_operation],input[name=_targetNamespace]':'changeMethodDetails',
            'change select[name=_operation]':'changeOperation',
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown",
            "click button[name=autoSend], button[name=autoReturn]"        : "autoComplete",
            "click button[id=xmlOpBrowse]"                                : "navToOps"
        };

        this.model.set('operations', [], { silent: true });

        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeMethodDetails(event){
        if (event.target.name === '_method' && event.target.value === 'SOAP'){
            this.navToOps();
        }else if (event.target.name === '_operation' && event.target.selectedIndex > 0)
        {
            this.getSendParameters(event.target.value);
        }
    
        return this.actionService.changeMethodDetails.apply(this.actionService, arguments);
    }

    itemNew(){
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        return this.actionService.itemRemove.apply(this.actionService, arguments);
    }

    itemDown(){
        return this.actionService.itemDown.apply(this.actionService, arguments);
    }

    itemUp(){
        return this.actionService.itemUp.apply(this.actionService, arguments);
    }

    autoComplete(e) {
        const advancedModal = new AutocompleteWebserviceModalView({
            model: new Model(this.model.get('currentActionDetails')), 
            title: "Auto Complete - SOAP Web Services Return Parameters", 
            text: "Enter a SOAP Web Service sample response XML (complete XML):",
            type: 'xml',
            isSend: false
        });

        advancedModal.render().then(paths => {
            if (paths) {
                const
                    currentModel = this.model.get('currentActionDetails'),
                    currentModelItems = [];

                paths.forEach(p => {
                    const value = p,
                        names = p.split('.'),
                        name = names[names.length - 1].replace('@', ' - '),
                        newRow = {
                            '_fixedValue': '',
                            '_id': sequenceService.nextDomId(),
                            '_isFixed': 'false',
                            '_name': name,
                            '_operation': -1,
                            '_value': value,
                            '_isNew': true
                        };
                    currentModelItems.push(newRow);
                });

                currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
                this.model.set('currentActionDetails', currentModel, {silent: true});
                this.model.set('hasChanges', true);
            }
        });
    }



    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGridsByType(){
        console.log("Re rendering Grid");
        const currentModel = this.model.get('currentActionDetails'),
            self=this;
        $('.stringResult,.xmlResult').addClass('hide');
        console.log("Current Model",currentModel);

        switch (currentModel.Type){
            case constants.CONNECTION_WEB_SERVICES_STRING_RESULT:

                const customHeight = 30; // TODO Make fn of min row count
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_WEB_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_STR_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_WEB_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_STR_RETURN_CONTAINER,
                    customHeight
                );
                $('.stringResult').removeClass('hide');
                break;

            case constants.CONNECTION_WEB_SERVICES_XML_RESULT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_WEB_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_XML_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_WEB_SERVICES_PARAMETER_HEADERS_XPATH,
                    constants.CONNECTION_XML_RETURN_CONTAINER
                );
                $('.xmlResult').removeClass('hide');
                break;
        }
        this.resizeGrid();
    }

    renderParameters(itemsToRender, tableId, tableName, colModel, colNames, placeholder){

        //Add id to rows.
        _.forEach(itemsToRender, (field, index) => {
            field.id = index;
        });

        let params = {
            id: tableId,
            title: tableName,
            height: 200,
            datatype: "local",
            cellEdit: true,
            colModel: colModel,
            colNames: colNames,
            multiselect: false,
            items: itemsToRender,
            filter: {tag: "Name", columnId: "_name"}
        }

        let newDashboard = new DashboardTable({ model: new Model({ tableOptions: params, currentView: this }), el: placeholder });
        newDashboard.render();
    }

    renderParametersGrid(colSendModel, colSendNames, colSendContainer,
            colReturnModel, colReturnNames, colReturnContainer, customHeight = 400){
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        let _cellEdit = true;
        let _sendCellEdit = true;
        if (currentModel.Type === constants.CONNECTION_WEB_SERVICES_STRING_RESULT) {
            _cellEdit = false;
        }
        if(this.model.get('unAllowedWebServiceType') === 'salesforce' || this.model.get('unAllowedWebServiceType') === 'sap'){
            _cellEdit = false;
            _sendCellEdit = false;
        }

        console.log("Current Action Details",currentModel);

        const sendItemsToRender=currentModel.ActionXML.Action.Send.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Send.Parameter
            : [currentModel.ActionXML.Action.Send.Parameter];

        const returnItemsToRender=currentModel.ActionXML.Action.Receive.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Receive.Parameter
            : [currentModel.ActionXML.Action.Receive.Parameter];
        
        let sendContainer = "#tbl-" + colSendContainer.replace("#",'');
        let returnContainer = "#tbl-" + colReturnContainer.replace("#",''); 

        this.renderParameters(sendItemsToRender, colSendContainer.replace("#",''), "Send Parameters",  colSendModel, colSendNames, sendContainer)
        this.renderParameters(returnItemsToRender, colReturnContainer.replace("#",''), "Return Parameters", colReturnModel, colReturnNames, returnContainer)

    }

    ondblClickRowSend (rowid, iRow,iCol){
        let containerToWork= '#' + this.id === constants.CONNECTION_STR_SEND_CONTAINER
            ? constants.CONNECTION_STR_SEND_CONTAINER
            : constants.CONNECTION_XML_SEND_CONTAINER;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    ondblClickRowReceive (rowid, iRow,iCol){
        let containerToWork= '#' + this.id === constants.CONNECTION_STR_RETURN_CONTAINER
            ? constants.CONNECTION_STR_RETURN_CONTAINER
            : constants.CONNECTION_XML_RETURN_CONTAINER;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol, currentView){

        let self = this || currentView;

        let currentGrid = self.model.get('currentGridSelector'),
            currentModel = self.model.get('currentActionDetails'),
            isSend = currentGrid.indexOf('Send') > 0;
        if (isSend) {
            if (cellName === '_value'
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] !== 'false') {
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_name'] = value;
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] = false;
            }
            else if (cellName === '_name') {
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] = true;
            }

            if (cellName !== '_path'){
                currentModel.ActionXML.Action.Send.Parameter[rowId][cellName] = value;
            }
        }
        else {
            if (cellName === '_value'
                && currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew']
                && currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] !== 'false') {

                currentModel.ActionXML.Action.Receive.Parameter[rowId]['_name'] = value;
                currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] = false;
            }
            currentModel.ActionXML.Action.Receive.Parameter[rowId][cellName] = value;
        }
        self.model.set('currentActionDetails', currentModel, { silent: true });
        self.model.set('hasChanges', true, { silent: true });
        self.model.trigger('change');
        console.log("Model After Save Cell", currentModel);
    }


    beforeSelectRow(rowId, e, currentView){
        console.log('before select row',e);
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
        currentView.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
    }//

    afterEditCell(rowId, cellName, value, iRow, iCol, currentView){
        $("#"+iRow+"_"+cellName).on('blur',function(){
            $(currentView.model.get('currentGridSelector')).saveCell(iRow,iCol);
        });
    }

    condDisableOpSelection() {
        const $btn = $('#xmlOpBrowse');
        $btn.removeAttr('disabled');

        if($('#xmlOperation').find('option').length < 1) {
            $btn.attr('disabled', 'disabled');
        }
    }

    navToOps() {
        const connectionId = this.model.get('connectionId');

        RestService.getConnectionDetails(connectionId).then((connectionDetails) => {
            const connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);
            const connectionObject = xJService.toJSON(connectionXML).Connection;
            
            let wsdlUrl = connectionObject['_wsdlUrl'];
            if (!connectionObject['_wsdlUrl'] || connectionObject['_wsdlUrl'] === '' &&
                connectionObject['_url'] && connectionObject['_url'] !== ''){
                    wsdlUrl = connectionObject['_url'] + '?wsdl';
            }
            const _username = connectionObject['_username'];
            const _password = connectionObject['_password'];
            const _useNameSpace = true; //Need to be true in order to retrieve all the elements regarding the actual value on Connection
            const _useNameSpaceOperation = 'ListAll';
            let getWSDLParams = { username: _username, password: _password, useNameSpace: _useNameSpace, useNameSpaceOperation: _useNameSpaceOperation };
            getWSDLParams.connectionId = connectionObject["_id"];

            const _wsdlSource = connectionObject['_wsdlSource'];
            const _wsdlFileName = connectionDetails.WsdlFileName;

            if(_wsdlSource === "file"){
                getWSDLParams.wsdlFileName = _wsdlFileName;
            }
            else{
                getWSDLParams.URL = wsdlUrl;
            }

            getWSDLParams.certificateName = connectionDetails.CertificateName;
           
            RestService.getWSDL(getWSDLParams).then((data) => {
                let operations = [];
                if (typeof data !== 'undefined' && data !== '') {
                    const wsdlObj = xJService.toJSON(data);              
                    let _targetNamespace = '';

                    if (wsdlObj.Operations){
                        operations = wsdlObj.Operations.Operation;
                        _targetNamespace = wsdlObj.Operations._targetNamespace;
                    }else if (wsdlObj['wsdl:definitions'] && wsdlObj['wsdl:definitions']['wsdl:binding']
                        && wsdlObj['wsdl:definitions']['wsdl:binding']) {
                        let _binding;
                        _targetNamespace = wsdlObj['wsdl:definitions']._targetNamespace;
                        if (Array.isArray(wsdlObj['wsdl:definitions']['wsdl:binding'])) {
                            _binding = wsdlObj['wsdl:definitions']['wsdl:binding'][0];
                        }else{
                            _binding = wsdlObj['wsdl:definitions']['wsdl:binding'];
                        }

                        if (Array.isArray(_binding['wsdl:operation'])) {
                            $.each(_binding['wsdl:operation'], function (index, _operation) {
                                operations.push({ _name: _operation._name });
                            });
                        } else {
                            operations.push({ _name: _binding['wsdl:operation']._name });
                        }                        
                    } else {
                        NotificationService.error('Invalid web service WSDL.');
                    }

                    let currentActionDetails = this.model.get('currentActionDetails');
                    currentActionDetails.ActionXML.Action._targetNamespace = _targetNamespace;

                    this.model.set('currentActionDetails', currentActionDetails, { silent: true });
                }

                if (!Array.isArray(operations)) {
                    operations = [_.clone(operations)];
                }

                operations.sort(function(a, b) {
                    return a._name.localeCompare(b._name);
                });

                this.model.set('operations', operations, { silent: true });
                this.model.set('hasChanges', true);
                this.render();
            }).catch((err) => {
                var errMsg = typeof err === 'string' ? err : 'Invalid web service WSDL.';
                NotificationService.error(errMsg);
            });
        }).catch((err) => {
            var errMsg = typeof err === 'string' ? err : 'Invalid web service WSDL.';
            NotificationService.error(errMsg);
        });
    }

    getSendParameters(operation) {
        const connectionId = this.model.get('connectionId');
        RestService.getConnectionDetails(connectionId).then((connectionDetails) => {
            const connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);
            const connectionObject = xJService.toJSON(connectionXML).Connection;

            let wsdlUrl = connectionObject['_wsdlUrl'];
            if (!connectionObject['_wsdlUrl'] || connectionObject['_wsdlUrl'] === '' &&
                connectionObject['_url'] && connectionObject['_url'] !== ''){
                    wsdlUrl = connectionObject['_url'] + '?wsdl';
            }            
            const _username = connectionObject['_username'];
            const _password = connectionObject['_password'];
            const _useNameSpace = true; //Need to be true in order to retrieve all the elements regarding the actual value on Connection
            const _useNameSpaceOperation = _useNameSpace ? operation : 'GetSendParameters';
            const _implementationType = connectionObject['_implType'] ? connectionObject['_implType'] : 'SOAPNET';
            let getWSDLParams = { username: _username, password: _password, useNameSpace: _useNameSpace, useNameSpaceOperation: _useNameSpaceOperation, implementationType: _implementationType };
            getWSDLParams.connectionId = connectionObject["_id"];
            const _wsdlSource = connectionObject['_wsdlSource'];
            const _wsdlFileName = connectionDetails.WsdlFileName;

            if(_wsdlSource === "file"){
                getWSDLParams.wsdlFileName = _wsdlFileName;
            }
            else{
                getWSDLParams.URL = wsdlUrl;
            }
            
            RestService.getWSDL(getWSDLParams).then((data) => {
                let operations = [];
                let _sendParameters = [];
                let retrievedSendParameters = [];
                if (typeof data !== 'undefined' && data !== '') {
                    data = data.replaceAll("xmlns=\"\"", "");
                    const wsdlObj = _useNameSpace ? xJService.toJSON(data) : JSON.parse(data);

                    if (wsdlObj) {
                        if (_useNameSpace && wsdlObj.Operation && wsdlObj.Operation.Request) {
                            _sendParameters = util.getDotNotationFromObject(wsdlObj.Operation.Request);
                        } else {
                            _sendParameters = wsdlObj[operation];
                        }
                    } else {
                        NotificationService.error('Invalid web service WSDL.');
                    }
                }

                if (!$.isArray(operations)) {
                    operations = [_.clone(operations)];
                }
                
                let currentActionDetails = this.model.get('currentActionDetails');
                if (_sendParameters) {
                    let currentActionDetails = this.model.get('currentActionDetails');
                    currentActionDetails.ActionXML.Action.Send.Parameter = [];
                    let _self = this;
                    $.each(_sendParameters, function (_index, _item) {
                        const _paramName = _useNameSpace ? _self.cleanSendParameterName(_item) : _item;
                        const newRow = {
                            '_fixedValue':'',
                            '_id': sequenceService.nextDomId(),
                            '_isFixed':'false',
                            '_name': _paramName,
                            '_operation': -1,
                            '_value': _item
                        };
                        currentActionDetails.ActionXML.Action.Send.Parameter.push(newRow);
                    });
                }

                this.model.set('currentActionDetails', currentActionDetails, { silent: true });
                this.model.set('hasChanges', true);
                this.render();
            }).catch((err) => {
                NotificationService.error('Invalid web service WSDL.');
            });
        }).catch((err) => {
            NotificationService.error('Invalid web service WSDL.');
        });
    }

    cleanSendParameterName(parameterName){
        let _cleanedParameterName = parameterName;
        if (parameterName && parameterName.length > 0){
            let _paramNameSplit = parameterName.split(".");
            if (_paramNameSplit.length > 0){
                _cleanedParameterName = _paramNameSplit[_paramNameSplit.length - 1];
            }
        }

        return _cleanedParameterName;
    }
    
    changeOperation(event){
        let currentActionDetails = this.model.get('currentActionDetails');
        currentActionDetails.ActionXML.Action._operationUrl = this.getOperationUrl(currentActionDetails.ActionXML.Action._targetNamespace, event.target.value);

        this.model.set('currentActionDetails', currentActionDetails, { silent: true });
    }

    getOperationUrl(targetNamespace, operation){
        let _targetNamespace = targetNamespace;
        let _operationUrl = operation;
        if ((typeof operation === 'undefined' || operation.length === 0) && (typeof _targetNamespace !== 'undefined' && _targetNamespace.length > 0)){
            if (_targetNamespace.substr(_targetNamespace.length -1) !== '/'){
                _targetNamespace += '/';
            }
            _operationUrl = _targetNamespace;
        }

        return _operationUrl;
    }

    relocateServiceDetails() {
        const containterWidth = ($(".actionGeneral").width() + 35);
        const containterHeight = ($(".actionGeneral").height() + 15);
        $(".serviceDetails").css({"width": containterWidth, "margin-top": containterHeight + "px", "margin-left": "-" + (containterWidth + 25) + "px"} )
    }
    
    onResize(){
        $(window).on('resize',() => {this.relocateServiceDetails();})
    }

    render(){
        console.log("Rendering Grids");
        let currentModel=this.model.get('currentActionDetails');

        let operations = this.model.get('operations');        
        if (currentModel.ActionXML.Action['_operation'] && (!operations || operations.length === 0)){
            this.model.set('operations', [{ _name: currentModel.ActionXML.Action['_operation'] }], { silent: true });
        }

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderGridsByType();

        $(`option[value="${currentModel.ActionXML.Action['_method']}"]`).prop('selected',true);        
        this.condDisableOpSelection();

        // If it's not SOAP and its XMLResult -> disable some elements
        if(currentModel.ActionXML.Action["_method"] !== "SOAP" && currentModel.Type === constants.CONNECTION_WEB_SERVICES_XML_RESULT)
        {
            $('select[name="_operation"]').prop("disabled", true);
            $('[id="xmlOpBrowse"]').prop("disabled", true);
            $('[name="_targetNamespace"]').prop("disabled", true);
        }else if (currentModel.ActionXML.Action["_method"] === "SOAP"){
            $('[name=_operation]').find("option[value='" + currentModel.ActionXML.Action['_operation'] + "']").attr('selected', true);
            $('select[name="_operation"]').prop("disabled", false);
            $('[id="xmlOpBrowse"]').prop("disabled", false);
            $('[name="_targetNamespace"]').prop("disabled", false);
        }

        this.relocateServiceDetails();

        this.delegateEvents();
        return this;
    }

}

export default ActionWebServices;